export default "__VITE_ASSET__B0t20P9f__"